import ProductHighlightWrapperProvider from './hooks/useProductHighlightWrapper';

import { ProductHighlightWrapperProps } from './@types/ProductHighlightWrapperProps';

const ProductHighlightWrapper = (props: ProductHighlightWrapperProps) => {
	const renderTokens = () => {
		if (props.blockClass) {
			return `vtex-product-highlights-2-x-productHighlightWrapper--${props.blockClass}`;
		}
	};

	return (
		<ProductHighlightWrapperProvider {...props}>
			<div
				data-selection={props.componentId}
				data-highlight-name="Oferta especial"
				className={`productHighlightWrapper productHighlightWrapper--${props.blockClass} vtex-product-highlights-2-x-productHighlightWrapper ${renderTokens()} .oferta-especial`}
			>
				{props.children}
			</div>
			<div
				data-selection={props.componentId}
				className={`productHighlightWrapper productHighlightWrapper--${props.blockClass} vtex-product-highlights-2-x-productHighlightWrapper ${renderTokens()}`}
			>
				{props.children}
			</div>
			<div
				data-selection={props.componentId}
				className={`productHighlightWrapper productHighlightWrapper--${props.blockClass} vtex-product-highlights-2-x-productHighlightWrapper ${renderTokens()}`}
			>
				{props.children}
			</div>
		</ProductHighlightWrapperProvider>
	);
};

export default ProductHighlightWrapper;
